var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankSlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4.25H6A5.75 5.75 0 0 0 .25 10v12.5A5.75 5.75 0 0 0 6 28.25h20a5.75 5.75 0 0 0 5.75-5.75V10A5.75 5.75 0 0 0 26 4.25ZM6 6.75h20A3.25 3.25 0 0 1 29.25 10v12.5A3.25 3.25 0 0 1 26 25.75H6a3.25 3.25 0 0 1-3.25-3.25V10A3.25 3.25 0 0 1 6 6.75Z",
    fill: "#65686A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 13.5c.69 0 1.25.56 1.25 1.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5c0-.69.56-1.25 1.25-1.25ZM9.25 13.5c.69 0 1.25.56 1.25 1.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5c0-.69.56-1.25 1.25-1.25ZM12.75 13.5c.69 0 1.25.56 1.25 1.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5c0-.69.56-1.25 1.25-1.25ZM17.75 13.5c.69 0 1.25.56 1.25 1.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5c0-.69.56-1.25 1.25-1.25ZM21.25 13.5c.69 0 1.25.56 1.25 1.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5c0-.69.56-1.25 1.25-1.25ZM25.75 13.5c.69 0 1.25.56 1.25 1.25v7.5a1.25 1.25 0 1 1-2.5 0v-7.5c0-.69.56-1.25 1.25-1.25Z",
    fill: "#65686A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSlip);
export default __webpack_public_path__ + "static/media/bank-slip.c65ae5092d244568c21404e2fb485ce3.svg";
export { ForwardRef as ReactComponent };